import {Controller} from "@hotwired/stimulus"
import {resetValues} from "../../../website/javascript/utils/html";

/**
 * This class is not intended to be used directly. You should inherit from it.
 */
export const Question2Base = class extends Controller {
  static targets = ["question2"];

  connect() {
    super.connect();
    this.showFacilitiesQuebec(this.element);
    this.showSubcontractors(this.element);

  }

  /** BEGIN: Frontend validations */
  showFacilitiesQuebec(target) {
    const facilitiesQuebecDiv = target.querySelector('.js-facilities-quebec');
    const changeNatureQuebecInputs = target.querySelectorAll('input[name*="change_nature_quebec"]');
    const changeProductUseQuebecInputs = target.querySelectorAll('input[name*="change_product_use_quebec"]');

    const showInputs = () => {
      const changeNatureQuebecSelected = target.querySelector('input[name*="change_nature_quebec"]:checked')?.value;
      const changeProductUseQuebecSelected = target.querySelector('input[name*="change_product_use_quebec"]:checked')?.value;

      if (changeNatureQuebecSelected === "true" || changeProductUseQuebecSelected === "true") {
        facilitiesQuebecDiv.classList.remove("d-none");
      } else {
        resetValues(facilitiesQuebecDiv);
        facilitiesQuebecDiv.classList.add("d-none");
        facilitiesQuebecDiv.dispatchEvent(new Event('change'));
      }
    }

    changeNatureQuebecInputs.forEach((r) => r.addEventListener('change', showInputs));
    changeProductUseQuebecInputs.forEach((r) => r.addEventListener('change', showInputs));

    showInputs();
  }

  showSubcontractors(target) {
    const subcontractorsDiv = target.querySelector('.js-subcontractors');
    const includesSubcontractors = target.querySelectorAll('input[name*="includes_subcontractors"]');

    const showInputs = () => {
      const includesSubcontractorsSelected = target.querySelector('input[name*="includes_subcontractors"]:checked')?.value;

      if (includesSubcontractorsSelected === "true") {
        subcontractorsDiv.classList.remove("d-none");
      } else {
        subcontractorsDiv.querySelectorAll(".remove_fields.existing").forEach((cocoonTrash) => {
          cocoonTrash.click();
        });
        subcontractorsDiv.classList.add("d-none");
        subcontractorsDiv.dispatchEvent(new Event('change'));
      }
    }

    includesSubcontractors.forEach((r) => r.addEventListener('change', showInputs));

    showInputs();
  }

  /** END: Frontend validations */
}

// For index.js auto-generated compilation
export default Controller;